const tiffExtensions = ['tif', 'tiff']
const tiffExtensionsForWhitelisting = tiffExtensions.map((tiffExtension) => `.${tiffExtension}`)
const whitelistedFilesList = [
    '.pdf',
    '.doc',
    '.docx',
    '.txt',
    '.jpg',
    '.jpeg',
    '.png',
    '.svg',
    '.bmp',
    '.csv',
    '.xls',
    '.xlsx',
    '.ods',
    '.odt',
    '.rtf',
    '.ppt',
    '.pptx',
    ...tiffExtensionsForWhitelisting,
]

const tiffContentType = 'image/tiff'

export const whitelistedFiles = whitelistedFilesList.join(',')

export const hasExtensions = (filename: string, wantedExtensions: string[]): boolean => {
    const givenExtension = getFileExtension(filename)
    if (givenExtension === null) {
        return false
    }

    return wantedExtensions.some((wantedExtensions) => wantedExtensions.toLowerCase() === givenExtension)
}

export const getFileExtension = (filename: string): string | null => {
    const fileParts = filename.toLowerCase().split('.')
    if (fileParts.length < 2 || !fileParts[fileParts.length - 1]) {
        return null
    }

    return fileParts[fileParts.length - 1]
}

export const hasTiffExtension = (filename: string): boolean => {
    return hasExtensions(filename, tiffExtensions)
}

export const getContentType = (contentType: string | undefined): string | null => {
    if (!contentType) {
        return null
    }

    return contentType.toLowerCase()
}

export const hasTiffContentType = (contentType: string | undefined): boolean => {
    return getContentType(contentType) === tiffContentType
}

const mimeTypeMapping: Record<string, string> = {
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'WORD',
    'application/msword': 'WORD',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'EXCEL',
    'application/vnd.ms-excel': 'EXCEL',
    'application/vnd.ms-excel.sheet.macroEnabled.12': 'EXCEL',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'POWERPOINT',
    'application/vnd.ms-powerpoint': 'POWERPOINT',
    'application/pdf': 'PDF',
    'text/csv': 'CSV',
    'application/json': 'JSON',
    'text/xml': 'XML',
    'application/xml': 'XML',
    'text/plain': 'TEXT',
    'image/jpeg': 'JPEG',
    'image/png': 'PNG',
    'image/gif': 'GIF',
    'image/bmp': 'BMP',
    'image/tiff': 'TIFF',
    'image/svg+xml': 'SVG',
    'application/zip': 'ZIP',
    'application/x-rar-compressed': 'RAR',
    'application/x-7z-compressed': '7Z',
    'application/x-tar': 'TAR',
    'application/octet-stream': 'Binary File',
}

export function translateMimeType(mimeType?: string, unknownLabel = 'Unbekannt') {
    if (mimeType === undefined) {
        return unknownLabel
    }
    return mimeTypeMapping[mimeType] || unknownLabel
}

export const isFileAboveMaxSize = (file: File, maxFileSizeBytes: number) => file.size > maxFileSizeBytes
